import { IResearchDataResponse, IResearchRequestPayload } from '@/creditflowresearch/domain/vo/research/IResearchResponse';
import { IResearchCollection } from '@/creditflowresearch/domain/vo/research/IResearchData';
import ResearchRepository from '@/creditflowresearch/infrastructure/repository/ResearchRepository';
import { EXCLUDED_SECTOR_IDS } from '@/creditflowresearch/application/Deal/constants';
import { getIndustryFilters, getSectorFilters, insertCompanyFilters } from '@/creditflowresearch/application/helpers';

const EMPTY_RESEARCH_COLLECTION: IResearchCollection = {
  collection: [],
  totalCount: 0,
};

export const filterResearchResponse = (
    payload: IResearchDataResponse,
    includedDocumentGroupId: string | null,
): IResearchCollection => {
  const data = (
      includedDocumentGroupId
          ? payload.byGroup[includedDocumentGroupId]
          : payload.all);

  return data?.researchCollection ?? EMPTY_RESEARCH_COLLECTION;
};

export const getTileDataPayload = (
    isTile: boolean,
    includedDocumentGroupId: string | null = null,
    includedDealIds: string[],
) => <IResearchRequestPayload>({
  filter: {
    dateFrom: null,
    dateTo: null,
    includedDocumentTypeIds: [],
    includedPseudoSectorIds: [],
    includedPublisherIds: [],
    includedDealIds,
    includedDocumentGroupId,
  },
  sortBy: 'publishedAt',
  sortOrder: 'desc',
  page: 1,
  perPage: isTile ? 10 : 25,
  search: '',
});

export const preparePayloadWithQuery = async (payload, context, isConsumerOverview) => {
  const { query, container } = context;
  const {
    hash,
    q = '',
    dateFrom = '',
    dateTo = '',
    companyViewId,
    sector,
    industry,
  } = query;
  const researchRepository = container.get(ResearchRepository);
  let { filter } = payload;

  if (hash) {
    const hashFilterPayload = await researchRepository.getResearchFilterByHash(hash);
    filter = { ...payload.filter, ...hashFilterPayload };
  }

  if (companyViewId) {
    try {
      const companyFilter = await insertCompanyFilters(context, filter);
      filter = { ...filter, ...companyFilter };
    } catch (e) {
      return { ...payload, filter };
    }
  }

  if (sector) {
    const sectorFilter = getSectorFilters(context);
    filter = { ...filter, ...sectorFilter };
  }

  if (industry) {
    const industryFilter = getIndustryFilters(context);
    filter = { ...filter, ...industryFilter };
  }

  if (isConsumerOverview) filter = { ...filter, excludedSectorIds: EXCLUDED_SECTOR_IDS };

  if (q) payload = { ...payload, search: q };
  if (dateFrom) filter = { ...filter, dateFrom: Number(dateFrom) };
  if (dateTo) filter = { ...filter, dateTo: Number(dateTo) };

  return { ...payload, filter };
};
